import { color } from '@upstox/upstox-ui';

export const modalContainer: CSSFunction = () => ({
  borderRadius: '4px !important',
});

export const contentContainer: CSSFunction = ({ theme }) => ({
  display: 'flex',
  padding: '24px',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  alignSelf: 'stretch',
  width: '480px',
  color: color(theme, 'text.1'),
  fontFamily: theme.fonts.body,
  fontSize: '12px !important',
});

export const description: CSSFunction = ({ theme }) => ({
  lineHeight: 'normal',
  fontSize: '14px',
  color: color(theme, 'text.2'),
});

export const checkboxContainer: CSSFunction = () => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
});

export const buttonContainer: CSSFunction = () => ({
  marginRight: '0px',
  marginLeft: 'auto',
  gap: '12px',
});

export const button = {
  width: '70px',
};
